import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
var SetupAndPairingSectionController = (function () {
    function SetupAndPairingSectionController($scope, productContextService, dynamicPagesSpotsDisplayOptionsService) {
        this.$scope = $scope;
        this.productContextService = productContextService;
        this.dynamicPagesSpotsDisplayOptionsService = dynamicPagesSpotsDisplayOptionsService;
    }
    SetupAndPairingSectionController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.setupAndPairingUrl = '';
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            _this.$scope.setupAndPairingUrl = '';
            if (typeof group !== 'object' || group === null) {
                return;
            }
            _this.dynamicPagesSpotsDisplayOptionsService
                .getSpotUrlOrEmpty(group.supportPageUrl, GroupRestrictedSpotType.GetStarted, _this.$scope, group.groupId, location.pathname + "/" + group.sku + "/get-started")
                .then(function (url) {
                _this.$scope.setupAndPairingUrl = url;
            });
        });
    };
    SetupAndPairingSectionController.$inject = ['$scope',
        'productContextService',
        'dynamicPagesSpotsDisplayOptionsService'];
    return SetupAndPairingSectionController;
}());
export { SetupAndPairingSectionController };
